import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useEffect, useRef } from 'react';
import { Animated, Easing, View } from 'react-native';

const kHeights = [8, 14, 10, 16, 8, 12];
/** Each bar its own beat, so the wave never pulses in step. */
const kBeatsMs = [420, 340, 470, 380, 450, 360];

/** A voice message's little waveform; it moves while the voice is heard. */
export const VoiceWave = memo(
  ({ color, active = false }: { color: string; active?: boolean }) => {
    const { rpx } = useResponsiveContext();
    const scales = useRef(kHeights.map(() => new Animated.Value(1))).current;
    useEffect(() => {
      if (!active) {
        scales.forEach(x => x.setValue(1));
        return;
      }
      const loops = scales.map((scale, i) =>
        Animated.loop(
          Animated.sequence([
            Animated.timing(scale, {
              toValue: 0.35,
              duration: kBeatsMs[i],
              easing: Easing.inOut(Easing.quad),
              useNativeDriver: true,
            }),
            Animated.timing(scale, {
              toValue: 1,
              duration: kBeatsMs[i],
              easing: Easing.inOut(Easing.quad),
              useNativeDriver: true,
            }),
          ]),
        ),
      );
      loops.forEach(x => x.start());
      return () => loops.forEach(x => x.stop());
    }, [active, scales]);
    return (
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
        {kHeights.map((height, i) => (
          <Animated.View
            key={i}
            style={{
              width: 2,
              height: rpx(height),
              borderRadius: 1,
              backgroundColor: color,
              transform: [{ scaleY: scales[i] }],
            }}
          />
        ))}
      </View>
    );
  },
);
